export const products = [
  {
    id: 'atum',
    name: 'Sanduíche de Atum',
    category: 'Sanduíches Naturais',
    weight: '140g',
    description: 'Delicioso sanduíche de atum com cenoura e salsa, preparado com ingredientes selecionados para um sabor leve e nutritivo.',
    shortDescription: 'Atum com cenoura e salsa, leve e nutritivo.',
    image: 'https://storage.helloreaddy.io/project_files/46b11d92-1101-4f92-aa67-f7a4033739d8/8e9b5b41-fc4f-4ff8-a388-9bd326efa7b0_compressed_ATUM.webp',
    ingredients: 'Pão de forma, maionese, atum, cenoura, proteína texturizada de soja e salsa.',
    allergens: 'Contém peixe e derivados de soja, trigo e ovo. Pode conter leite. Contém glúten.',
    storage: 'Manter refrigerado de 0°C a 10°C e após aberto consumir imediatamente.',
    validity: '10 dias',
    packaging: 'Selada a vácuo com embalagem de material PET + PETMETAL + PE + 100% verniz.',
    tags: ['Natural', 'Proteico', 'Leve'],
    imageQuery: 'Artisanal%20tuna%20sandwich%20on%20whole%20wheat%20bread%20with%20fresh%20carrots%20and%20parsley%2C%20cinematic%20food%20photography%2C%20natural%20window%20light%2C%20wooden%20table%20surface%2C%20shallow%20depth%20of%20field%2C%20warm%20earthy%20tones%2C%20editorial%20food%20magazine%20style%2C%20minimal%20composition%2C%20soft%20shadows%2C%20organic%20feel',
    nutritional: {
      portion: '40 g (3 1/2 fatias)',
      portionsPerPack: 'Cerca de 4',
      items: [
        { label: 'Valor energético', per100g: '208 Kcal', perPortion: '83 Kcal', vd: '4' },
        { label: 'Carboidratos', per100g: '27 g', perPortion: '11 g', vd: '4' },
        { label: 'Açúcares totais', per100g: '4,1 g', perPortion: '1,7 g', vd: '-' },
        { label: 'Açúcares adicionados', per100g: '2,8 g', perPortion: '1,2 g', vd: '2' },
        { label: 'Proteínas', per100g: '9,1 g', perPortion: '3,6 g', vd: '7' },
        { label: 'Gorduras totais', per100g: '6,8 g', perPortion: '2,8 g', vd: '4' },
        { label: 'Gorduras saturadas', per100g: '1,3 g', perPortion: '0,5 g', vd: '3' },
        { label: 'Gorduras trans', per100g: '0 g', perPortion: '0 g', vd: '0' },
        { label: 'Fibras alimentares', per100g: '1,9 g', perPortion: '0,8 g', vd: '3' },
        { label: 'Sódio', per100g: '544 mg', perPortion: '218 mg', vd: '11' },
      ],
    },
  },
  {
    id: 'frango-milho',
    name: 'Sanduíche Filé de Frango com Milho',
    category: 'Sanduíches Naturais',
    weight: '140g',
    description: 'Sanduíche de filé de frango desfiado com milho e cenoura, uma combinação clássica e saborosa para o seu dia a dia.',
    shortDescription: 'Frango desfiado com milho e cenoura, clássico e saboroso.',
    image: 'https://storage.helloreaddy.io/project_files/46b11d92-1101-4f92-aa67-f7a4033739d8/64aa4e3d-baf8-4bc0-b154-b58fdb078581_compressed_FRANGO-COM-MILHO.webp',
    ingredients: 'Pão de forma, patê de filé de frango (maionese, filé de frango desfiado, milho, cenoura, proteína texturizada de soja, caldo de galinha e salsa).',
    allergens: 'Contém derivados de soja, trigo e ovo. Pode conter leite. Contém glúten.',
    storage: 'Manter refrigerado de 0°C a 10°C e após aberto consumir imediatamente.',
    validity: '10 dias',
    packaging: 'Selada a vácuo com embalagem de material PET + PETMETAL + PE + 100% verniz.',
    tags: ['Natural', 'Proteico', 'Tradicional'],
    imageQuery: 'Cinemmatic%20chicken%20sandwich%20with%20corn%20and%20carrots%20on%20artisanal%20bread%2C%20professional%20food%20photography%2C%20soft%20natural%20lighting%2C%20wooden%20background%2C%20shallow%20depth%20of%20field%2C%20warm%20color%20palette%2C%20editorial%20style%2C%20fresh%20ingredients%20visible%2C%20clean%20composition',
    nutritional: {
      portion: '40 g (3 1/2 fatias)',
      portionsPerPack: 'Cerca de 4',
      items: [
        { label: 'Valor energético', per100g: '209 Kcal', perPortion: '84 Kcal', vd: '4' },
        { label: 'Carboidratos', per100g: '29 g', perPortion: '12 g', vd: '4' },
        { label: 'Açúcares totais', per100g: '4,5 g', perPortion: '1,8 g', vd: '-' },
        { label: 'Açúcares adicionados', per100g: '2,8 g', perPortion: '1,2 g', vd: '2' },
        { label: 'Proteínas', per100g: '11 g', perPortion: '4,3 g', vd: '9' },
        { label: 'Gorduras totais', per100g: '5,5 g', perPortion: '2,2 g', vd: '3' },
        { label: 'Gorduras saturadas', per100g: '1,1 g', perPortion: '0,4 g', vd: '2' },
        { label: 'Gorduras trans', per100g: '0 g', perPortion: '0 g', vd: '0' },
        { label: 'Fibras alimentares', per100g: '2,0 g', perPortion: '0,8 g', vd: '3' },
        { label: 'Sódio', per100g: '536 mg', perPortion: '214 mg', vd: '11' },
      ],
    },
  },
  {
    id: 'frango-requeijao',
    name: 'Sanduíche Filé de Frango com Requeijão',
    category: 'Sanduíches Naturais',
    weight: '140g',
    description: 'Sanduíche de filé de frango desfiado com requeijão cremoso e cenoura, uma opção rica em proteínas e extremamente saborosa.',
    shortDescription: 'Frango desfiado com requeijão cremoso e cenoura, rico em proteínas.',
    image: 'https://storage.helloreaddy.io/project_files/46b11d92-1101-4f92-aa67-f7a4033739d8/20f3e663-9b3f-4e87-b1db-82cb062c3821_compressed_FRANGO-COM-RAQUEIJAO.webp',
    ingredients: 'Pão de forma, patê de filé de frango (maionese, filé de frango desfiado, requeijão, cenoura, proteína texturizada de soja, caldo de galinha e salsa).',
    allergens: 'Contém lactose. Contém derivados de soja, trigo, ovo e leite. Contém glúten.',
    storage: 'Manter refrigerado de 0°C a 10°C e após aberto consumir imediatamente.',
    validity: '10 dias',
    packaging: 'Selada a vácuo com embalagem de material PET + PETMETAL + PE + 100% verniz.',
    tags: ['Natural', 'Proteico', 'Cremoso'],
    imageQuery: 'Gourmet%20chicken%20sandwich%20with%20cream%20cheese%20and%20fresh%20carrots%2C%20professional%20food%20photography%2C%20diffused%20natural%20light%2C%20rustic%20wooden%20board%2C%20shallow%20depth%20of%20field%2C%20warm%20earthy%20colors%2C%20editorial%20magazine%20style%2C%20appetizing%20texture%2C%20clean%20minimalist%20composition',
    nutritional: {
      portion: '40 g (3 1/2 fatias)',
      portionsPerPack: 'Cerca de 4',
      items: [
        { label: 'Valor energético', per100g: '226 Kcal', perPortion: '90 Kcal', vd: '5' },
        { label: 'Carboidratos', per100g: '28 g', perPortion: '11 g', vd: '4' },
        { label: 'Açúcares totais', per100g: '4,9 g', perPortion: '2,0 g', vd: '-' },
        { label: 'Açúcares adicionados', per100g: '2,8 g', perPortion: '1,2 g', vd: '2' },
        { label: 'Proteínas', per100g: '12 g', perPortion: '5,0 g', vd: '10' },
        { label: 'Gorduras totais', per100g: '7,3 g', perPortion: '2,9 g', vd: '4' },
        { label: 'Gorduras saturadas', per100g: '2,8 g', perPortion: '1,1 g', vd: '6' },
        { label: 'Gorduras trans', per100g: '0 g', perPortion: '0 g', vd: '0' },
        { label: 'Fibras alimentares', per100g: '2,6 g', perPortion: '1,0 g', vd: '4' },
        { label: 'Sódio', per100g: '471 mg', perPortion: '189 mg', vd: '9' },
      ],
    },
  },
  {
    id: 'peito-peru',
    name: 'Sanduíche Peito de Peru',
    category: 'Sanduíches Integrais',
    weight: '140g',
    description: 'Sanduíche de peito de peru com requeijão e salsa, uma opção leve e saborosa, ideal para quem busca praticidade sem abrir mão da qualidade.',
    shortDescription: 'Peito de peru com requeijão e salsa, leve e prático.',
    image: 'https://storage.helloreaddy.io/project_files/46b11d92-1101-4f92-aa67-f7a4033739d8/7ec0c018-a7e2-4406-a2c8-76bebcf23bac_compressed_PEITO-DE-PERU.webp',
    ingredients: 'Pão de forma, requeijão, maionese, peito de peru e salsa.',
    allergens: 'Contém lactose. Contém derivados de soja, trigo, ovo e leite. Contém glúten.',
    storage: 'Manter refrigerado de 0°C a 10°C e após aberto consumir imediatamente.',
    validity: '10 dias',
    packaging: 'Selada a vácuo com embalagem de material PET + PETMETAL + PE + 100% verniz.',
    tags: ['Integral', 'Leve', 'Tradicional'],
    imageQuery: 'Delicious%20turkey%20breast%20sandwich%20with%20cream%20cheese%20on%20artisanal%20bread%2C%20professional%20food%20photography%2C%20soft%20natural%20light%20from%20window%2C%20wooden%20surface%2C%20shallow%20depth%20of%20field%2C%20warm%20neutral%20tones%2C%20editorial%20food%20styling%2C%20fresh%20herbs%20garnish%2C%20appetizing%20presentation',
    nutritional: {
      portion: '40 g (3 1/2 fatias)',
      portionsPerPack: 'Cerca de 4',
      items: [
        { label: 'Valor energético', per100g: '222 Kcal', perPortion: '89 Kcal', vd: '4' },
        { label: 'Carboidratos', per100g: '27 g', perPortion: '11 g', vd: '4' },
        { label: 'Açúcares totais', per100g: '5,3 g', perPortion: '2,1 g', vd: '-' },
        { label: 'Açúcares adicionados', per100g: '2,8 g', perPortion: '1,2 g', vd: '2' },
        { label: 'Proteínas', per100g: '10 g', perPortion: '4,0 g', vd: '8' },
        { label: 'Gorduras totais', per100g: '8,1 g', perPortion: '3,2 g', vd: '5' },
        { label: 'Gorduras saturadas', per100g: '3,3 g', perPortion: '1,3 g', vd: '7' },
        { label: 'Gorduras trans', per100g: '0 g', perPortion: '0 g', vd: '0' },
        { label: 'Fibras alimentares', per100g: '2,6 g', perPortion: '1,0 g', vd: '4' },
        { label: 'Sódio', per100g: '477 mg', perPortion: '191 mg', vd: '10' },
      ],
    },
  },
];

export const productCategories = [
  'Todos',
  'Sanduíches Naturais',
  'Sanduíches Integrais',
  'Wraps',
  'Lanches Saudáveis',
  'Opções Fitness',
];